import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { RouteConfig } from 'react-router-config'
import { Store } from 'redux'

import {
  resetAlerts,
  resetErrorPage,
  setCanonicalPath
} from '../../common/actions/common'
import { setUserSearchResultsViewType } from '../../common/actions/user/preference'
import { IRootState } from '../../common/reducers'
import { IEnhancedLocation } from '../../common/reducers/reactRouterLocation'
import { IAlertPayload } from '../../typings/alert'
import PendingNavDataLoader from '../components/pendingNavDataLoader'

interface IOwnProps {
  routes: RouteConfig[]
  store: Store<IRootState>
}

interface IStateProps {
  location: IEnhancedLocation
  alerts: IAlertPayload[]
  errorPage?: any
  currentSite: Site
}

interface IDispatchProps {
  resetAlerts: () => any
  resetErrorPage: () => any
  setCanonicalPath: (path: string) => any
  setUserSearchResultsViewType: (view: string) => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const {
    router: { location },
    common: { alerts, errorPage, currentSite }
  } = state

  return {
    location,
    alerts,
    errorPage,
    currentSite
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
) => {
  return {
    resetAlerts: () => dispatch(resetAlerts()),
    resetErrorPage: () => dispatch(resetErrorPage()),
    setCanonicalPath: (path: string) => dispatch(setCanonicalPath(path)),
    setUserSearchResultsViewType: (view: string) =>
      dispatch(setUserSearchResultsViewType(view))
  }
}

export type Props = IOwnProps & IStateProps & IDispatchProps

const createPendingNavDataLoaderContainer = (
  component: React.ComponentType<Props>
) => {
  return connect<IStateProps, IDispatchProps, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createPendingNavDataLoaderContainer(PendingNavDataLoader)
